import {pick} from 'lodash';

import {PERSISTENT_STORE_LOCAL_STORAGE_KEY, LocalStorageKeys} from '~/shared/consts/localStorageConsts';
import {safeLocalStorage} from '~/shared/utils/safeStorage';

import {resyncLatestPersistStore} from './persistStoreMiddleware';

export const clearReleventStorageData = () => {
  const currentLocalStorageValue = safeLocalStorage.getJSON(PERSISTENT_STORE_LOCAL_STORAGE_KEY);

  const a11yLocalStorage = pick(currentLocalStorageValue, 'a11y');
  const ActiveOrderDismissedBanners = safeLocalStorage.getJSON(LocalStorageKeys.DISMISSED_ACTIVE_ORDERS);
  const lastOtlRedirectTimestamp = safeLocalStorage.getJSON(LocalStorageKeys.LAST_OTL_REDIRECT_TIMESTAMP);
  const cookieConsentTimestamp = safeLocalStorage.getItem(LocalStorageKeys.COOKIE_CONSENT_TIMESTAMP);
  safeLocalStorage.clear();

  safeLocalStorage.setJSON(PERSISTENT_STORE_LOCAL_STORAGE_KEY, a11yLocalStorage);
  safeLocalStorage.setJSON(LocalStorageKeys.DISMISSED_ACTIVE_ORDERS, ActiveOrderDismissedBanners);
  if (lastOtlRedirectTimestamp) {
    safeLocalStorage.setJSON(LocalStorageKeys.LAST_OTL_REDIRECT_TIMESTAMP, lastOtlRedirectTimestamp);
  }
  if (cookieConsentTimestamp) {
    safeLocalStorage.setItem(LocalStorageKeys.COOKIE_CONSENT_TIMESTAMP, cookieConsentTimestamp);
  }

  // Keep the middleware's in-memory snapshot consistent with the storage we just cleared,
  // so the `pagehide`/`unload` dump during logout's hard navigation can't write the stale
  // (pre-logout) scopes back and resurrect e.g. the current address.
  resyncLatestPersistStore();
};
